import { useState } from 'react'
import { httpService } from '../../services/http-service'
import { CompanyTable } from '../../cmps/company/company-table'
import { CompanyFormModal } from '../../cmps/company/company-form-modal'
import { Spinner } from '../../cmps/util-cmps/spinner'
import { useCachedFetch } from '../../hooks/use-cached-fetch'

const GET_COMPANIES = `
{
  companies{
    id
    name
    abbreviation
    logoUrl
    isSilo
    createdAt
  }
}
`

export const CompaniesPage: React.FC = () => {
    const { data, isLoading, hasError, refetch } = useCachedFetch(
        'companies',
        async () => {
            const result = await httpService.graphql('auditech', GET_COMPANIES)
            return result.companies as any[]
        }
    )

    const [isModalOpen, setIsModalOpen] = useState(false)
    const [companyToEdit, setCompanyToEdit] = useState<any>(null)

    const openCreateModal = () => {
        setCompanyToEdit(null)
        setIsModalOpen(true)
    }

    const openEditModal = (company: any) => {
        setCompanyToEdit(company)
        setIsModalOpen(true)
    }

    const closeModal = () => {
        setIsModalOpen(false)
        setCompanyToEdit(null)
    }

    const handleSuccess = () => {
        closeModal()
        refetch()
    }

    return <div className="tablePageContainer">
        <div className="page-header">
            <p className="tableSubtitle">Manage companies and their configurations.</p>
            <button className="add-btn" onClick={openCreateModal}>
                <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round">
                    <line x1="12" y1="5" x2="12" y2="19" />
                    <line x1="5" y1="12" x2="19" y2="12" />
                </svg>
                Create Company
            </button>
        </div>
        {isLoading && <Spinner />}
        {!isLoading && !hasError && <CompanyTable data={data || []} onEditClick={openEditModal} />}
        {!isLoading && hasError && <div className="error-hint">Failed to load data. Try refreshing the page or re-logging in.</div>}

        {isModalOpen && <CompanyFormModal
            key={companyToEdit?.id || 'create'}
            companyToEdit={companyToEdit}
            existingNames={(data || []).map((c: any) => c.name)}
            onSuccess={handleSuccess}
            onClose={closeModal}
        />}
    </div>
}
